import { IconProps } from "../IconProps";

export const IconUser24 = ({ className, color = "#FFF" }: IconProps) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 22C4 17.7044 7.58173 14.2222 12 14.2222C16.4183 14.2222 20 17.7044 20 22M16.5714 6.44444C16.5714 8.89904 14.5247 10.8889 12 10.8889C9.47527 10.8889 7.42857 8.89904 7.42857 6.44444C7.42857 3.98984 9.47527 2 12 2C14.5247 2 16.5714 3.98984 16.5714 6.44444Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
